import { ProjectOverview } from './../state/seller/project-overview/reducer';
import { request } from '@/utils/ajax';
import { HttpStatusCode } from '@/HttpStatusCodes';
import { SellerChangeRequestStatus } from '@/types';

export interface ProjectTaskCount {
    documents: number;
    projectDocuments: number;
    buyerOptionGroups: number;
    orders: number;
    // changeRequests: number;
}

export interface ProjectTaskCountOverview {
    tasks: ProjectTaskCount;
    projectId: number;
    numberOfTasks: number;
}
export interface ProjectSpendingRow {
    rootItemCategoryId: number;
    totalSpending: number;
    averageSpending: number;
}

export interface ProjectSpending {
    totalSpending: number;
    averageSpending: number;
    details: ProjectSpendingRow[];
}

export interface ProjectResidentialUnitAvailability {
    unitsTotal: number;
    unitsSold: number;
}

export interface DeadlineOverviewRow {
    projectDeadlineId: number;
    projectDeadlineName: string;
    unitsWithOptionsSent: number;
    unitsWithOptionsTotal: number;
}

export function getProjectDashboardUnsubmittedUnits(projectId: number): Promise<number> {
    return request(`api/project/${projectId}/dashboard/units-unsubmitted`).then((x) => x.json());
}

export function getProjectDashboardSpending(projectId: number): Promise<ProjectSpending> {
    return request(`api/project/${projectId}/dashboard/spending`).then((x) => x.json());
}

export function getProjectDashboardAvailability(projectId: number): Promise<ProjectResidentialUnitAvailability> {
    return request(`api/project/${projectId}/dashboard/availability`).then((x) => x.json());
}

export function getProjectDashboardTimeToOffer(projectId: number): Promise<number> {
    return request(`api/project/${projectId}/dashboard/time-to-offer`).then((x) =>
        x.status === HttpStatusCode.NoContent ? null : x.json()
    );
}
export function getProjectDashboardDeadlineOverview(projectId: number): Promise<DeadlineOverviewRow[]> {
    return request(`api/project/${projectId}/dashboard/deadlines`).then((x) => x.json());
}

export function getProjectTaskCountForProfile(profileId: number): Promise<ProjectOverviewSimplified[]> {
    return request(`api/profile/${profileId}/projects/task-count`).then((x) => x.json());
}

export interface ProjectOverviewSimplified {
    projectId: number;
    unreadThreadCount: number;
    taskCount: number;
    totalCount: number;
}

export interface ChangeRequestStatusOverview {
    items: ChangeRequestStatusOverviewItem[];
    total: number;
}
export interface ChangeRequestStatusOverviewItem {
    status: SellerChangeRequestStatus;
    count: number;
}
export function getProjectChangeRequestStatusOverview(projectId: number): Promise<ChangeRequestStatusOverview> {
    return request(`api/project/${projectId}/dashboard/change-request`).then((x) => x.json());
}